import React from "react";
import {
  Field,
  Fieldset,
  FieldGroup,
  Label,
  ErrorMessage,
} from "../../../../design/fieldset";
import { Input } from "../../../../design/input";
import { Select } from "../../../../design/select";
import { SideType, sideTypes } from "../../../../models/SideType";

interface Props {
  formState: {
    file: File | null;
    name: string;
    filingDate: string;
    side: SideType;
  };
  setFormState: React.Dispatch<
    React.SetStateAction<{
      file: File | null;
      name: string;
      filingDate: string;
      side: SideType;
    }>
  >;
  error?: string | null;
}

const FilingDetailsStep: React.FC<Props> = ({
  formState,
  setFormState,
  error,
}) => {
  const update = (key: keyof typeof formState, value: any) => {
    setFormState((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Fieldset>
      <FieldGroup>
        <Field>
          <Label>Name</Label>
          <Input
            type="text"
            value={formState.name}
            onChange={(e) => update("name", e.target.value)}
            placeholder="Name"
          />
        </Field>

        <Field>
          <Label>Filing Date</Label>
          <Input
            type="date"
            value={formState.filingDate}
            onChange={(e) => update("filingDate", e.target.value)}
          />
        </Field>

        <Field>
          <Label>Side</Label>
          <Select
            value={formState.side}
            onChange={(e) => update("side", e.target.value as SideType)}
          >
            <option value="" disabled>
              Select side
            </option>
            {Object.entries(sideTypes).map(([key, value]) => (
              <option key={key} value={key}>
                {value}
              </option>
            ))}
          </Select>
        </Field>

        {error && <ErrorMessage>{error}</ErrorMessage>}
      </FieldGroup>
    </Fieldset>
  );
};

export default FilingDetailsStep;
